import { z } from 'zod'

export const ValidateDiscountCodeSchema = z.object({
    code: z.string().min(1, 'Le code promo est requis'),
    cart_id: z.string().min(1, 'cart_id requis'),
})

export const RemoveDiscountCodeSchema = z.object({
    cart_id: z.string().min(1),
    code: z.string().min(1),
})
